import { styled } from "@material-ui/styles";

export const AuthWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  minHeight: "100vh"
}));
